import {useShortTermDisabilityCoveragePopulator} from '../populator/useShortTermDisabilityCoveragePopulator';
import {useDispatch} from 'react-redux';

export const useShortTermDisabilityCoverageDispatcher = () => {
    const populateShortTermDisabilityCoverage = useShortTermDisabilityCoveragePopulator();
    const dispatch = useDispatch();

    const dispatchCoverage = (selectedRate) => {
        const data = populateShortTermDisabilityCoverage(selectedRate);
        dispatch({
            type: 'UPDATE_MEMBER_ELECTION',
            data: data
        });
    };

    return (selectedRate) => dispatchCoverage(selectedRate);
};